import { FORMAT_DATE_TIME } from '@/utils'

export default FORMAT_DATE_TIME
